<script setup>
const props = defineProps({
  servizi: {
    type: Array,
    default: () => [],
  },
  category: {
    type: String,
    required: true,
  },
})

const route = useRoute()

const selectedServizio = ref(null)

const selectServizio = (servizio) => {
  selectedServizio.value = servizio
}

const categoryTitle = computed(() => {
  if (props.category === 'infanzia') {
    return "Scuola dell'Infanzia"
  } else if (props.category === 'primaria') {
    return 'Scuola Primaria'
  }
  return ''
})

const isActive = (servizio) => {
  return route.path === `/${props.category}/${servizio.slug}`
}
</script>

<template>
  <div class="fixed-menu-container">
    <div class="fixed-menu p-top-xxl-b">
      <h2 class="text-xs-1 title is-x-bold">{{ categoryTitle }}</h2>
      <ul>
        <li
          v-for="servizio in servizi"
          :key="servizio.slug"
          :class="[
            {
              active: isActive(servizio),
              'underline-animation': !isActive(servizio),
            },
          ]"
          class="text-xxs-1"
          @click="selectServizio(servizio)"
        >
          <nuxt-link :to="`/${category}/${servizio.slug}`">
            {{ servizio.titolo }}
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FixedSideMenu',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
